import { ButtonGroup, Container } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ButtonsMenu = ({ data, titulo, exportarCSV, exportaExcel }) => {
  const downloadExcel = async () => {
    if(exportaExcel) {
      exportaExcel();
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = await XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const currentDate = new Date().toISOString().split('T')[0];
    if(titulo === undefined || titulo === null || titulo === "") {
      titulo = "Datos_Generados";
    }
    saveAs(blob, `${titulo}_${currentDate}.xlsx`);
  };
  const exportCSV = () => {
    if(exportarCSV) {
      exportarCSV();
    }
  };
  return (
    <Container>
      <ButtonGroup>
        <button type="button" className='btn btn-primary' 
            onClick={() => downloadExcel()} 
            data-tooltip-id='tooltiparriba'
            data-tooltip-content="Descargar Excel" >
                Descargar Excel
        </button>
        {exportarCSV && <button type="button"  className='btn btn-primary' 
            onClick={() => exportCSV()} 
            data-tooltip-id='tooltiparriba'
            data-tooltip-content="Descargar CSV" >
                Descargar CSV
        </button>}
      </ButtonGroup>
    </Container>
  );
};

export default ButtonsMenu;
